import axios from '../axios';
const END_POINT = '/permission-groups';

const addPermissionGroups = (group) => axios.post(`${END_POINT}`, group);
const getPermissionGroups = () => axios.get(`${END_POINT}`);
const getAPermissionGroup = (id) => axios.get(`${END_POINT}/${id}`);
const deletePermissionGroup = (permission) => axios.delete(`${END_POINT}/${permission}`);
const editPermissionGroups = (permission, id) => axios.patch(`${END_POINT}/${id}`, permission);


export {
    addPermissionGroups, getPermissionGroups, deletePermissionGroup,getAPermissionGroup, editPermissionGroups
}